document.addEventListener("DOMContentLoaded", function () {
  const loginForm = document.getElementById("login-form");
  const forgotPasswordForm = document.getElementById("forgot-password-form");
  const forgotPasswordBtn = document.getElementById("forgot-password-btn");
  const backToLoginBtn = document.getElementById("back-to-login-btn");
  const forgotPasswordMessage = document.getElementById(
    "forgot-password-message"
  );

  // Show Forgot Password Form
  if (forgotPasswordBtn) {
    forgotPasswordBtn.addEventListener("click", function () {
      loginForm.style.display = "none";
      forgotPasswordForm.style.display = "block";

      if (forgotPasswordMessage) {
        forgotPasswordMessage.style.display = "none";
      }
    });
  }

  if (forgotPasswordForm) {
    // Handle Forgot Password Form Submission via AJAX
    forgotPasswordForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Get the form data
      const formData = new FormData(forgotPasswordForm);

      // Send the AJAX request
      fetch(forgotPasswordForm.action, {
        method: "POST",
        body: formData,
      })
        // .then((response) => response.text())
        // .then((data) => {
        //   if (forgotPasswordMessage) {
        //     forgotPasswordMessage.style.display = "block";
        //   }

        //   forgotPasswordForm.reset();
        // })
        .catch((error) => {
          console.error("Error submitting the form:", error);
        }).finally(() => {
                 if (forgotPasswordMessage) {
            forgotPasswordMessage.style.display = "block";
          }

          forgotPasswordForm.reset();
        });
    });
  }

  if (backToLoginBtn) {
    // Go Back to Login
    backToLoginBtn.addEventListener("click", function () {
      forgotPasswordForm.style.display = "none";
      loginForm.style.display = "block";

      if (forgotPasswordMessage) {
        forgotPasswordMessage.style.display = "none";
      }
    });
  }

  const emailField = document.querySelector("#input_4_3");
	const newPasswordField = document.querySelector("#input_4_9");
	const confirmNewPasswordField = document.querySelector("#input_4_9_2");
  const currentPasswordField = document.querySelector("#input_4_4");

  if (emailField) {
    emailField.setAttribute("autocomplete", "email");
  }
  if (currentPasswordField) {
    currentPasswordField.setAttribute("autocomplete", "current-password");
  }
	if (newPasswordField) {
    newPasswordField.setAttribute("autocomplete", "new-password");
  }
  if (confirmNewPasswordField) {
    confirmNewPasswordField.setAttribute("autocomplete", "new-password");
  }
});
